exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".commerce-data {\n  margin: 0;\n  padding: 0 15px;\n  clear: both;\n  position: relative;\n  top: 0; }\n  .commerce-data .m2 {\n    background: #ffffff;\n    padding-bottom: 10px; }\n\n.custom-menu.customer-tabs {\n  margin: 0;\n  border: 0;\n  position: relative;\n  bottom: -5px;\n  padding: 0 !important; }\n  .custom-menu.customer-tabs li {\n    margin: 0; }\n\n.btn {\n  padding: 10px; }\n\n.my-catalog-profile {\n  padding: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/buyer/commerce/commerce.component.scss
// module id = 491
// module chunks = 0